import React, { useState } from "react";
import {
  ConnectAccountManagement,
  ConnectAccountOnboarding,
  ConnectBalances,
  ConnectComponentsProvider,
  ConnectNotificationBanner,
  ConnectPayments,
  ConnectPayoutsList,
} from "@stripe/react-connect-js";
import useStripeConnect from "../../../hooks/useStripeConnect";
import { useHistory } from "react-router-dom";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";

const ConnectComponent = ({ accountId, accountDetails }) => {
  const { stripeConnectInstance, instanceLoading } = useStripeConnect(
    accountId
  );

  const history = useHistory();

  const [loading, setLoading] = useState(true);
  const [tabIndex, setTabIndex] = useState(0);
  const [message, setMessage] = useState("");

  const handleNotificationsChange = (response) => {
    if (response.actionRequired > 0) {
      setMessage(
        "You must resolve the notifications on this page before proceeding."
      );
    } else if (response.total > 0) {
      setMessage("The items below are in review.");
    } else {
      setMessage("");
    }
  };

  const onLoadError = (loadError) => {
    const componentName = loadError.elementTagName;
    const error = loadError.error;
    console.log(componentName + " failed to load");
    console.log(`${error.type}: ${error.message}`);
  };

  const onLoaderStart = (event) => {
    setLoading(false);
    console.log(`${event.elementTagName} is visible to users`);
  };

  const onExit = (event) => {
    history.push("/account-list");
  };

  return (
    <div className="">
      {instanceLoading ? (
        <div className="w-100 h-100 d-flex justify-content-center align-items-center">
          Creating Connect Account Session....
        </div>
      ) : (
        <ConnectComponentsProvider connectInstance={stripeConnectInstance}>
          <div className="row">
            <div className="col-8">
              <div className="card mb-3">
                <div className="card-body">
                  <ConnectBalances />
                </div>
              </div>
            </div>

            <div className="col-4">
              <div className="card mb-3">
                <div className="card-body">
                  <p>Connect Details</p>
                  <p>
                    <strong>Account ID:</strong> {accountDetails?.accountId}
                  </p>
                  <p>
                    <strong>Status:</strong>{" "}
                    {accountDetails?.isVerified ? (
                      <span style={{ color: "green" }}>Verified</span>
                    ) : (
                      <span style={{ color: "red" }}>Not Verified</span>
                    )}
                  </p>
                </div>
              </div>
            </div>

            <div className="col-12">
              <div className={`${message ? "card mb-3" : "d-none"}`}>
                <div className="card-header">{message}</div>
                <div className="card-body">
                  <ConnectNotificationBanner
                    onNotificationsChange={handleNotificationsChange}
                    collectionOptions={{
                      fields: "eventually_due",
                      futureRequirements: "include",
                    }}
                  />
                </div>
              </div>

              <div className="card mb-3">
                <Tabs
                  className="theme-tab my-3"
                  selectedIndex={tabIndex}
                  onSelect={(index) => setTabIndex(index)}
                >
                  <TabList className="tabs tab-title">
                    <div className="card-header">
                      <Tab>Account Managment</Tab>
                      <Tab>Payment</Tab>
                      <Tab>Payouts</Tab>
                      <Tab>Details</Tab>
                    </div>
                  </TabList>

                  <div className="card-body">
                    <TabPanel>
                      <div className="no-slider row">
                        <ConnectAccountManagement
                          collectionOptions={{
                            fields: "eventually_due",
                            futureRequirements: "include",
                          }}
                        />
                      </div>
                    </TabPanel>
                    <TabPanel>
                      <div className="no-slider row">
                        <ConnectPayments />
                      </div>
                    </TabPanel>
                    <TabPanel>
                      <div className="no-slider row">
                        <ConnectPayoutsList />
                      </div>
                    </TabPanel>
                    <TabPanel>
                      <div className="no-slider row">
                        {loading && "Loading"}
                        <ConnectAccountOnboarding
                          collectionOptions={{
                            fields: "eventually_due",
                            futureRequirements: "include",
                          }}
                          onExit={onExit}
                          onLoadError={onLoadError}
                          onLoaderStart={onLoaderStart}
                        />
                      </div>
                    </TabPanel>
                  </div>
                </Tabs>
              </div>
            </div>
          </div>
        </ConnectComponentsProvider>
      )}
    </div>
  );
};

export default ConnectComponent;
